export const TableColumns = {
  LAST_UPDATED: 'LAST_UPDATED',
  VIEWS_COUNTER: 'VIEWS_COUNTER',
  FAVORITES: 'FAVORITES',
  FAVORITES_COUNTER: 'FAVORITES_COUNTER',
  CONTRIBUTORS: 'CONTRIBUTORS',
  SEARCH_BAR: 'SEARCH_BAR',
};
